import { render, staticRenderFns } from "./ReceivableStatement.vue?vue&type=template&id=5b8a6da3&scoped=true&"
import script from "./ReceivableStatement.vue?vue&type=script&lang=js&"
export * from "./ReceivableStatement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b8a6da3",
  null
  
)

export default component.exports